// extracted by mini-css-extract-plugin
export default {"root":"RenderAlerts_root__oxnoD"};